import React from 'react';
import '../template-file-css/document-file-template.css';


export const CBS_NpRequestedForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CBS_NpRequestedForm' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <input type='text' id='txtMaleFemale' name='txtMaleFemale' className='add-only w-200 custom-add-only' />  male/ female has agreed to MM appt via telehealth. Denies driving a vehicle and states is private and able to talk without interruption.

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>CC:</span>
                    <textarea id='txtCc' name='txtCc' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Vitals Signs:</span>
                    <textarea id='txtVitalsSigns' name='txtVitalsSigns' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>SE to Medication:</span>
                    <textarea id='txtSeMedication' name='txtSeMedication' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Last PCP Appt:</span>
                    <textarea id='txtLastPcp' name='txtLastPcp' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'> <b>Mental Status</b> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Appearance:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Affect:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAppearance' name='txtAppearance' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAffect' name='txtAffect' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>SH ideations:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Unsecured weapons:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtShIdeations' name='txtShIdeations' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtUnsecuredWeapons' name='txtUnsecuredWeapons' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Danger:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>AV hallucinations:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtDanger' name='txtDanger' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAvHallucinations' name='txtAvHallucinations' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Sleep:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Appetite:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Mood:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='text' id='txtSleep' name='txtSleep' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtAppetite' name='txtAppetite' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtMood' name='txtMood' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Thought processing reading mind, sending special messages, inserting thoughts?</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <input type='text' id='txtThoughtProcessing' name='txtThoughtProcessing' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Orientation:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Speech:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtOrientation' name='txtOrientation' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSpeech' name='txtSpeech' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Behavior:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Substances:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtBehavior' name='txtBehavior' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSubstances' name='txtSubstances' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Tobacco:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Skin rash:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtTobacco' name='txtTobacco' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSkinRash' name='txtSkinRash' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Akathisia:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAkathisia' name='txtAkathisia' className='add-only' /> </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>Plan:</span>
                    <textarea id='txtPlan' name='txtPlan' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>RTC:</span>
                    <ol>
                        <li>
                            Continue medication as follows: 
                            Orders to 
                            <input type='text' id='txtOrdersTo' name='txtOrdersTo' className='add-only w-150 custom-add-only' /> pharmacy, number 
                            <input type='text' id='txtOrdersToNumber' name='txtOrdersToNumber' className='add-only w-100 custom-add-only' />
                            writer electronically:
                            <input type='text' id='txtOrdersToNumberElectronically' name='txtOrdersToNumberElectronically' className='add-only w-100 custom-add-only' />

                        </li>
                        <li>Writer advised client to abstain from substance use/ abuse. Client verbalized understanding</li>
                        <li>Writer ordered- CMP, CBC w dill, hemoglobin A1C and lipid panel, tasty visit, client states lab completed results pending WKMC Bossier/ please obtain results</li>
                        <li>Writer adviced client to call 911 or go to the nearest Emergency Room if he becomes suicidal or homicidal. Client  verbalizes understanding</li>
                        <li>Writer reviewed client's profile in Louisiana prescription monitoring program- -penthouse /</li>
                    </ol>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Tangential:</span>
                    <textarea id='txtTangential' name='txtTangential' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Perseveration:</span>
                    <textarea id='txtPerseveration' name='txtPerseveration' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Rumination:</span>
                    <textarea id='txtRumination' name='txtRumination' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Circumstantial:</span>
                    <textarea id='txtCircumstantial' name='txtCircumstantial' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Loose:</span>
                    <textarea id='txtLoose' name='txtLoose' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Consciousness:</span>
                    <textarea id='txtConsciousness' name='txtConsciousness' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Reduced:</span>
                    <textarea id='txtReduced' name='txtReduced' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Clouded:</span>
                    <textarea id='txtClouded' name='txtClouded' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Narrowed:</span>
                    <textarea id='txtNarrowed' name='txtNarrowed' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Expanded:</span>
                    <textarea id='txtExpanded' name='txtExpanded' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Apperception:</span>
                    <textarea id='txtApperception' name='txtApperception' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Phobia:</span>
                    <textarea id='txtPhobia' name='txtPhobia' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Compulsion:</span>
                    <textarea id='txtCompulsion' name='txtCompulsion' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Hypochondriac:</span>
                    <textarea id='txtHypochondriac' name='txtHypochondriac' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>OCD:</span>
                    <textarea id='txtOCD' name='txtOCD' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Delusional:</span>
                    <span className='small'>(persecution, ,Guilt, poverty,Hypochondrial, Mania periods of great Excitement,delecusions overactivity)</span>
                    <textarea id='txtDelusional' name='txtDelusional' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Euphoric:</span>
                    <textarea id='txtEuphoric' name='txtEuphoric' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Dysphoria:</span>
                    <textarea id='txtDysphoria' name='txtDysphoria' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parathymia:</span>
                    <textarea id='txtParathymia' name='txtParathymia' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Parkinesia:</span>
                    <textarea id='txtParkinesia' name='txtParkinesia' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Loss of ego boundaries</b>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Derealization:</span>
                    <textarea id='txtDerealization' name='txtDerealization' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Depersonalization:</span>
                    <textarea id='txtDepersonalization' name='txtDepersonalization' className='add-only'></textarea>
                </p> 
                <p className='w-750'>
                    <span className='eleHeader'>Thought broadcasting:</span>
                    <textarea id='txtThoughtBroadcasting' name='txtThoughtBroadcasting' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Thought insertions:</span>
                    <textarea id='txtThoughtinsertions' name='txtThoughtinsertions' className='add-only'></textarea>
                </p> 
                <p className='w-750'>
                    <span className='eleHeader'>Withdrawal:</span>
                    <textarea id='txtWithdrawal' name='txtWithdrawal' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Neologisms:</span>
                    <textarea id='txtNeologisms' name='txtNeologisms' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Ambivalence:</span>
                    <textarea id='txtAmbivalence' name='txtAmbivalence' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Affective lability:</span>
                    <textarea id='txtAffectiveLability' name='txtAffectiveLability' className='add-only'></textarea>
                </p>  




            </div>
        </form>

    )
}











